import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchTransactionHistory = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getTransactionManagementPage',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, {
    endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
    fromImpcs: payload.params.fromImpcs,
    status: null,
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    toImpcs: payload.params.toImpcs,
    transactionTypeCode: null,
  });
};

export default apiFetchTransactionHistory;
